export const PLAYBACK_ENUM = Object.freeze({
  //playback
  PLAYING: "playback_playing",
  PAUSED: "playback_paused",
  //simulation
  SIMULATION_READY: "simulation_ready",
  SIMULATION_ENDED: "simulation_ended",
  SIMULATION_RUNNING: "simulation_running",
});

export const initControlsState = {
  play: PLAYBACK_ENUM.PAUSED, //PLAYING | PAUSED | BUFFERING
  seek: 0,
  speed: 1,
};

export const SPEED_OPTIONS = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 5, label: "5" },
  { value: 10, label: "10" },
];
